<template>
  <Section :content="intelligentPDF" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionIntelligentPDF',
  components: {
    Section,
  },
  data() {
    return {
      intelligentPDF: { 
        eyebrow: 'IntelligentPDF\u2122',
        eyebrowIcon: 'icon-ipdf.png',
        headline: 'Find Information 10x Faster',
        paragraphs: [
          'Crosslink transforms your PDFs into a structured, hyperlinked, and instantly searchable IntelligentPDF\u2122.', 
          'Trinity finds system tags and creates an object for that tag. All uses of the tag get a link to the tag object.'
        ],
        id: 'intelligent-pdf',
        videoId: '686343471',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
        /*html:
          '<div>' + 
          ' <h3>Find Information 10x Faster</h3>' +
          ' <p>Your AI agent Trinity transforms your PDFs into a structured, hyperlinked, and instantly searchable IntelligentPDF\u2122.</p>' +
          ' <p>Trinity finds system tags and creates an object for that tag. All uses of the tag get a link to the tag object.</p>' +
          '</div>',*/
        learnMoreLink: '/intelligent-pdf'
      }
      /*intelligentPDF: { 
        header: 'IntelligentPDF\u2122',
        headerIcon: 'icon-ipdf.png',
        id: 'intelligent-pdf',
        videoId: 686343471,
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
        html:
          '<div>' + 
          '  <h3><p>Our conceptual AI Trinity reads your PDFs for you and transforms them into intelligentPDFs.</p>' + 
          '  <p>The IntelligentPDF\u2122 creates a hierarchy of actionable content from the pdf file</p></h3>' +
          '  <ul>' + 
          '   <li>Structured into sections, single pages & sheets.</li>' +
          '   <li>Each page/sheet contains its Units-of-Thought in space/time.</li>' +
          '   <li>Finds and adds hyperlinks between sheets.</li>' +
          '   <li>Finds and adds metadata, such as sheet number, title and discipline, for each sheet.</li>' +
          '  <li>Saves you time by reading the documents for you.</li>' + 
          '  <li>Search finds precisely what you need.</li>' + 
          '  <li>Quickly access your data in the field, regardless of the quality of your internet connection</li>' + 
          '  <ul>' + 
          '   <li>Search across thousands of documents.</li>' +
          '   <li>From documents containing thousands of pages and sheets, quick download the one single sheet where the information you need is located.</li>' +
          '   <li>Instant navigation between referenced sheets.</li>' + 
          '  </ul>' +
          ' </ul>' + 
          '</div>',
        learnMoreLink: '/intelligent-pdf'
      }*/
    }
  }
};
</script>
